module.exports = __webpack_public_path__ + "static/media/je.862cd38b.svg";